module.exports = __webpack_public_path__ + "images/FUSA_icons/005-watch.f9bccc197cb097678af7ff138fdec1f6.svg";